import request from '@/router/axios'

export const getList = (current, size, params, deptId) => request({
  url: '/api/mcc-worker/attendancescheme/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    deptId,
  },
})

export const add = params => request({
  url: '/api/mcc-worker/attendancescheme/save',
  method: 'post',
  data: params,
})
export const update = params => request({
  url: '/api/mcc-worker/attendancescheme/update',
  method: 'post',
  data: params,
})
export const remove = ids => request({
  url: '/api/mcc-worker/attendancescheme/remove',
  method: 'post',
  params: {
    ids,
  },
})

export default {
  getList,
}
